import { FC } from 'react';
import styled from 'styled-components';

const DEFAULT_PADDING = 20;

const TabViewElement = styled.div<IProps>`
  grid-area: tabview;
  overflow: ${({ overflow }) => overflow || 'auto'};
  display: flex;
  flex-direction: column;
`;

const ContentElement = styled.div<IProps>`
  padding: ${props => (props.padding != null ? props.padding : DEFAULT_PADDING)}px;
  padding-left: 0px;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

const HeadingElement = styled.div`
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 40px;
`;

export interface IProps {
  /** The id of the tab. Defaults to undefined. */
  tabId?: string;
  /** Optional heading text.  Defaults to undefined. */
  heading?: string;
  /** Padding in pixels. Defaults to 20px. */
  padding?: number;
  /** id for custom identification of tab view. Defaults to undefined. */
  id?: string;
  /** Overflow type. Defaults to "auto" */
  overflow?: string;
}

export const TabView: FC<IProps> = props => {
  return (
    <TabViewElement data-testid="TabViewElement" overflow={props.overflow}>
      <ContentElement padding={props.padding}>
        {props.heading && <HeadingElement>{props.heading}</HeadingElement>}
        {props.children}
      </ContentElement>
    </TabViewElement>
  );
};
